defineCustomVueElement('csb-model-picker', {
  name: 'Model Picker',
  template: `<div id="model-picker">
  <div class="page-width">
    <h2>Model Picker</h2>
    <div class="row grid grid--1-col grid--2-col-tablet grid--2-col-desktop">
      <div class="grid__item">
        <h2>Select your brand:</h2>
        <ul>
          <li v-for="(item) in brands" @click="selectBrand(item)" style="cursor: pointer" :class="{ active: item.id == brand, 'option-item': true }"><span :class="item.name.toLowerCase()">{{ item.name }}</span></li>
        </ul>
      </div>
      <div class="grid__item" v-if="brand != ''">
        <h2>Select your model:</h2>
        <ul v-if="models.length">
          <li v-for="(model, id) in models" @click="goToCategory(id)" style="cursor: pointer" class="option-item">{{ model.brand + ' ' + model.name }} ({{ model.sub_group }})</li>
        </ul>
      </div>
    </div>
  </div>
</div>`,
    data() {
      return {
        brand: '',
        model: '',
        csbStore: useCsbStore()
      }
    },
    methods: {
      selectBrand(item) {
        console.log(item)
        this.brand = item.id
      },
      goToCategory(id) {
        var model = this.models[id]        
        localStorage.setItem("model-picker-chosen", JSON.stringify(model));
        if (model.uri != null) {
          window.location = model.uri;
        } else {
          alert('No can do fella!')
          
        }
      }
    },
    computed: {
      brands() {
        if (this.csbStore.groups.length == 0) {
          return []
        }
        var output = this.csbStore.groups.reduce((result, current) => { result[current.brand.id] = current.brand; return result; }, [])
        return Object.values(output).sort((a, b) => {
          var aName = a.name.toLowerCase()
          var bName = b.name.toLowerCase()
          if (aName > bName) {
            return 1
          }
          if (aName < bName) {
            return -1
          }
          return 0
        })
      },
      models() {       
        if (this.brand == '') {
          return [];
        } else {
          var output = this.csbStore.groups.filter(i => i.brand.id == this.brand).reduce((result, current) => { 
            var collection_uri = null;
            if (current.collection != null) {
              collection_uri = current.collection.uri
            }
            Array.prototype.push.apply(result, current.models.map(m => { return { name: m, uri: collection_uri, sub_group: current.name, group: current.group, brand: current.brand.name, brand_id: current.brand.id }})); return result; }, [])
          if (output.length == 0) {
            return [ { name: 'View All', uri: null, group: 'Universal' } ];
          }
          return Object.values(output).sort((a, b) => {
            var aName = a.name.toLowerCase()
            var bName = b.name.toLowerCase()
            if (aName > bName) {
              return 1
            }
            if (aName < bName) {
              return -1
            }
            return 0
          })
        }
      }
    },
    async mounted() {
      await this.csbStore.init()
    }
}, { plugins: [ piniaStore ] })